import { render, staticRenderFns } from "./SocialLoginHandler.vue?vue&type=template&id=7464e56a&"
import script from "./SocialLoginHandler.vue?vue&type=script&lang=js&"
export * from "./SocialLoginHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports